







































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { LocaleMessage } from "vue-i18n";
import HeaderCurrency from "@/components/header/HeaderCurrency.vue";
import HeaderSettings from "@/components/header/HeaderSettings.vue";

@Component({
  components: {
    HeaderCurrency,
    HeaderSettings,
  },
  computed: {
    ...mapGetters("network", { networkDefaults: "defaults" }),
    ...mapGetters("ui", ["menuVisible"]),
  },
})
export default class HeaderDefault extends Vue {
  private placeholder: LocaleMessage | string = "Search";
  private networkDefaults: any;
  private menuVisible: boolean;

  get showCurrency(): boolean {
    return this.networkDefaults.priceChartOptions.enabled;
  }

  public mounted() {
    const WIDTH_THRESHOLD = 1024;
    const widthQuery = window.matchMedia(`(max-width: ${WIDTH_THRESHOLD}px)`);

    widthQuery.addListener((e) => this.setMobilePlaceholder(e.matches));

    this.setMobilePlaceholder(window.innerWidth < WIDTH_THRESHOLD);
  }

  private setMobilePlaceholder(showMobile: boolean) {
    if (!this.$i18n) {
      return;
    }
    this.placeholder = showMobile ? this.$i18n.t("SEARCH.PLACEHOLDER.SHORT") : this.$i18n.t("SEARCH.PLACEHOLDER.LONG");
  }
}
